export default __webpack_public_path__ + "static/media/insta.6a54f5b5.svg";